import axios from "axios";

// Base URL of your NestJS server
const BASE_URL = process.env.REACT_APP_BACKEND_URL;

// Create an Axios instance
const server = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

// Add a request interceptor
server.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
server.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 401 || error.response.status === 404) {
        console.error("Unauthorized. Please login again.");
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
      if (error.response.status === 403) {
        console.error("Forbidden. You don’t have permission to access this resource.");
      }
    } else if (error.request) {
      console.error("No response from server. Please try again later.");
    } else {
      console.error("Error", error.message);
    }
    return Promise.reject(error);
  }
);

export default server;
